export const GROUP = {
  id: 1,
  name: 'LooooooooongName group',
  type: 'Business',
  description:
    'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Duis nulla risus, vestibulum a mi quis.',
  image: null,
  members_qty: 45000,
  rules: [
    {
      id: 1,
      description:
        'Description Description Description Description Description Description Description Description',
    },
    {
      id: 2,
      description:
        'Description Description Description Description Description Description Description Description',
    },
    {
      id: 3,
      description:
        'Description Description Description Description Description Description Description Description',
    },
    {
      id: 4,
      description:
        'Description Description Description Description Description Description Description Description',
    },
    {
      id: 5,
      description:
        'Description Description Description Description Description Description Description Description',
    },
    {
      id: 6,
      description:
        'Description Description Description Description Description Description Description Description',
    },
  ],
  tags: [
    {
      id: 1,
      name: 'tagName1',
    },
    {
      id: 2,
      name: 'tagName2',
    },
    {
      id: 3,
      name: 'tagName3',
    },
    {
      id: 4,
      name: 'tagName4',
    },
    {
      id: 5,
      name: 'tagName5',
    },
  ],
  blogs: [],
  admins: [
    {
      first_name: 'Brandon',
      last_name: 'Wood',
      roles: [
        {
          name: 'individual',
        },
      ],
      avatar: null,
      inviter: 'Robert Fox',
      experiences: [
        {
          title: 'CEO',
          company_name: 'Gillette',
        },
      ],
    },
    {
      first_name: 'Brandon',
      last_name: 'Wood',
      roles: [
        {
          name: 'individual',
        },
      ],
      avatar: null,
      inviter: 'Robert Fox',
      experiences: [
        {
          title: 'CEO',
          company_name: 'Gillette',
        },
      ],
    },
  ],
  allMembers: [
    {
      first_name: 'Brandon',
      last_name: 'Wood',
      roles: [
        {
          name: 'individual',
        },
      ],
      avatar: null,
      inviter: 'Robert Fox',
      experiences: [
        {
          title: 'CEO',
          company_name: 'Gillette',
        },
      ],
    },
    {
      first_name: 'Brandon',
      last_name: 'Wood',
      roles: [
        {
          name: 'individual',
        },
      ],
      avatar: null,
      inviter: 'Robert Fox',
      experiences: [
        {
          title: 'CEO',
          company_name: 'Gillette',
        },
      ],
    },
    {
      first_name: 'Brandon',
      last_name: 'Wood',
      roles: [
        {
          name: 'individual',
        },
      ],
      avatar: null,
      inviter: 'Robert Fox',
      experiences: [
        {
          title: 'CEO',
          company_name: 'Gillette',
        },
      ],
    },
  ],
  events: [
    {
      id: 1,
      name: 'Virtual Writing Hour with the National Portrait Gallery',
      date: 'Thu, Sep 1, 2022 8:30 PM EEST',
      location: 'Flurstrasse 62, 8048, Zürich - Schweiz',
    },
    {
      id: 2,
      name: 'Virtual Writing Hour with the National Portrait Gallery',
      date: 'Thu, Sep 1, 2022 8:30 PM EEST',
      location: 'Flurstrasse 62, 8048, Zürich - Schweiz',
    },
    {
      id: 3,
      name: 'Virtual Writing Hour with the National Portrait Gallery',
      date: 'Thu, Sep 1, 2022 8:30 PM EEST',
      location: 'Flurstrasse 62, 8048, Zürich - Schweiz',
    },
    {
      id: 4,
      name: 'Virtual Writing Hour with the National Portrait Gallery',
      date: 'Thu, Sep 1, 2022 8:30 PM EEST',
      location: 'Flurstrasse 62, 8048, Zürich - Schweiz',
    },
    {
      id: 5,
      name: 'Virtual Writing Hour with the National Portrait Gallery',
      date: 'Thu, Sep 1, 2022 8:30 PM EEST',
      location: 'Flurstrasse 62, 8048, Zürich - Schweiz',
    },
    {
      id: 6,
      name: 'Virtual Writing Hour with the National Portrait Gallery',
      date: 'Thu, Sep 1, 2022 8:30 PM EEST',
      location: 'Flurstrasse 62, 8048, Zürich - Schweiz',
    },
  ],
};
